import { Route, RouteObject } from 'react-router-dom';

export const buildRoutes = (routes: RouteObject[]) => {
	const renderRoutes = (routeList: RouteObject[]) =>
		routeList.map((route, index) => {
			const { path, element, children, index: isIndex } = route;

			if (isIndex) {
				// Index route: no path allowed
				return (
					<Route key={index} index element={element}>
						{children && renderRoutes(children)}
					</Route>
				);
			}

			// Normal route
			return (
				<Route key={index} path={path} element={element}>
					{children && renderRoutes(children)}
				</Route>
			);
		});

	return renderRoutes(routes);
};
